import React from 'react';
import './RankedPhaseHintModal.css';
import PageButton from '../../elements/PageButton/PageButton';

const PAGE_ID = 'RankedPhaseHintModal';

/**
 * Правила текущей фазы подготовки рейтингового лобби — банов фракций либо
 * выбора фракции после них (тексты см. в LobbyPage).
 *
 * Дублирует подсказку по наведению с той же иконки: на тачскрине наведения
 * нет вовсе, и атрибут title там не показывается никогда — а правила банов
 * первый раз нужно где-то прочитать.
 */
function RankedPhaseHintModal({title, lines = [], onHide}) {
  return (
    <div className="ranked-phase-hint-overlay" onClick={onHide} role="dialog" aria-modal="true">
      <div className="ranked-phase-hint-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="ranked-phase-hint-title">{title}</h2>
        {lines.map((line) => (
          <p className="ranked-phase-hint-text" key={line}>{line}</p>
        ))}
        <div className="main-menu-buttons ranked-phase-hint-buttons">
          <PageButton onClick={onHide} pageId={PAGE_ID} buttonId="hide">
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default RankedPhaseHintModal;
